import { Header4 } from '@cian/ui-kit';

import * as React from 'react';
import classNames from 'classnames';

import { VerificationStep } from '../VerificationStep';
import { PreviewBlock } from '../PreviewBlock';

import { VERIFICATION_STEP_TEXT } from './config';
import * as styles from './styles.css';

export interface IAboutBlock {
  isMobile?: boolean;
  className?: string;
  title: string;
}

export const AboutBlock: React.FC<IAboutBlock> = ({ isMobile, className, title }) => (
  <div className={classNames(styles['root'], { [styles['mobile']]: isMobile }, className)}>
    <div className={styles['content']}>
      <Header4>{title}</Header4>

      <div className={styles['steps']}>
        {VERIFICATION_STEP_TEXT.map((text, index) => (
          <VerificationStep index={index + 1} key={index} className={styles['verification-step']} isMobile={isMobile}>
            {isMobile ? text.mobile : text.desktop}
          </VerificationStep>
        ))}
      </div>
    </div>

    {!isMobile && <PreviewBlock className={styles['preview-block']} />}
  </div>
);

AboutBlock.displayName = 'AboutBlock';
